import moment from 'moment';
import 'moment/locale/es';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { FiUserPlus } from 'react-icons/fi';
import { CreateMatriculadoForm } from '../forms/CreateMatriculadoForm';
moment.locale('es');

const CreateMatriculadoModal = ({ setModalShow, modalShow }) => {
  return (
    <Modal
      show={modalShow}
      onHide={() => {
        setModalShow(false);
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title className="fw-light">
          <FiUserPlus /> Nuevo Matriculado
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <CreateMatriculadoForm setModalShow={setModalShow} />
      </Modal.Body>
    </Modal>
  );
};

CreateMatriculadoModal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired
};

export default CreateMatriculadoModal;
